export const analysisBundle = {
  all: { ko: "전체", en: "All", es: "Todo" },
  dong: { ko: "{dong} 동", en: "Building {dong}", es: "Edificio {dong}" },
  dongho: {
    ko: "{dong}동 {ho}호",
    en: "Buidling {dong} unit {ho}"
  }
}
